import { render, staticRenderFns } from "./TopicFilter.vue?vue&type=template&id=21de3acc"
import script from "./TopicFilter.ts?vue&type=script&lang=ts&external"
export * from "./TopicFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports